import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

/**
 * Reducer for engagementProfiles state.
 * State is pre-populated via incomingPreloadedState from the Hercules Web host application
 * when running in MFE mode.
 * @param {Array} state - The current engagementProfiles array.
 * @param {Object} action - Action object containing type and other values.
 * @return {Array} current state or updated engagement profiles array.
 */
export default function engagementProfileReducer(state = initialState.engagementProfiles, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_PROFILE_DATA: {
			return action.response;
		}
		default:
			return state;
	}
}
